<template>
    <header class="checkout-header">
        <div class="checkout-header-title">{{ title }}</div>
        <div v-if="!isMobile" class="checkout-header-info">{{ info }}</div>
        <div class="checkout-header-actions">
            <a href="#" id="btnCloseCheckout" @click.prevent="$emit('close-checkout')">
                <span class="material-icon icon-clear"></span>
            </a>
        </div>
    </header>
</template>

<style lang="scss">
    .checkout-header {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100px;
        top: 0;
        left: 0;
        padding: 15px 60px;
        background-color: var(--bg-color);
        z-index: 1;

        a {
            &,
            &:hover,
            &:focus {
                color: var(--text-color);
                text-decoration: none;
            }
        }

        > div {
            width: calc(100% / 3);
        }

        &-title {
            color: var(--text-color);
            font-size: 1.5rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &-info {
            color: var(--text-secondary-color);
            font-size: .87rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
        }

        &-actions {
            text-align: right;
        }

        .material-icon {
            font-size: 2.12rem !important;
        }
    }

    body.-is-mobile {

        .checkout-header {
            padding-left: 20px;
            padding-right: 20px;

            &-title {
                width: 100%;
            }

            &-actions {
                width: auto;
            }
        }
    }
</style>

<script>
  import checkoutHeader from 'src/mixins/checkoutHeaderComponent';

  export default {
    mixins: [checkoutHeader],
  };
</script>
